import { defineMessages } from 'react-intl';

export default defineMessages({
  unknownError: {
    id: 'system.errorMessages.unknownError',
    defaultMessage: 'Something went wrong, please try again.',
  },
});
